// @flow
import { Style, Stroke } from 'ol/style';

export default new Style({
    stroke: new Stroke({
        color: '#C4B62C',
        width: 1,
        lineDash: [1, 3]
    })
});